// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-switcher {
  position: relative;
  display: inline-block;
}

.lang-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  color: white;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  min-width: 110px;
  justify-content: space-between;
  padding: 8px 12px;
}

.lang-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
}

.lang-icon {
  font-size: 14px;
  color: white;
  flex-shrink: 0;
}

.lang-text {
  flex: 1 1;
  text-align: left;
  font-size: 13px;
  color: white;
  margin-left: 4px;
}

.lang-chevron {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.9);
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.lang-chevron.open {
  transform: rotate(180deg);
}

.lang-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 180px;
  overflow: hidden;
}

.lang-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: white;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
  color: #333;
  font-size: 13px;
}

.lang-item:hover {
  background-color: #f5f5f5;
}

.lang-item.active {
  background-color: #e3f2fd;
  color: #2563eb;
}

.language-option.active .language-native {
  font-weight: 600;
}

.language-native {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 2px;
}

.language-english {
  font-size: 12px;
  color: #666;
  font-style: italic;
}

.language-option.active .language-native,
.language-option.active .language-english {
  color: #1976d2;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .lang-btn {
    min-width: 78px;
    padding: 6px 8px;
    gap: 4px;
    font-size: 12px;
    border-radius: 6px;
  }

  .lang-icon {
    font-size: 13px;
  }

  .lang-text {
    font-size: 12px;
  }

  .lang-chevron {
    font-size: 9px;
  }

  .language-dropdown {
    min-width: 160px;
    right: -10px;
  }

  .language-option {
    padding: 10px 14px;
  }

  .language-native {
    font-size: 13px;
  }

  .language-english {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LanguageSwitcher.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".language-switcher {\n  position: relative;\n  display: inline-block;\n}\n\n.lang-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  color: white;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  min-width: 110px;\n  justify-content: space-between;\n  padding: 8px 12px;\n}\n\n.lang-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.lang-icon {\n  font-size: 14px;\n  color: white;\n  flex-shrink: 0;\n}\n\n.lang-text {\n  flex: 1;\n  text-align: left;\n  font-size: 13px;\n  color: white;\n  margin-left: 4px;\n}\n\n.lang-chevron {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.9);\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.lang-chevron.open {\n  transform: rotate(180deg);\n}\n\n.lang-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 4px;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  min-width: 180px;\n  overflow: hidden;\n}\n\n.lang-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  background: white;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  text-align: left;\n  color: #333;\n  font-size: 13px;\n}\n\n.lang-item:hover {\n  background-color: #f5f5f5;\n}\n\n.lang-item.active {\n  background-color: #e3f2fd;\n  color: #2563eb;\n}\n\n.language-option.active .language-native {\n  font-weight: 600;\n}\n\n.language-native {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 2px;\n}\n\n.language-english {\n  font-size: 12px;\n  color: #666;\n  font-style: italic;\n}\n\n.language-option.active .language-native,\n.language-option.active .language-english {\n  color: #1976d2;\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n  .lang-btn {\n    min-width: 78px;\n    padding: 6px 8px;\n    gap: 4px;\n    font-size: 12px;\n    border-radius: 6px;\n  }\n\n  .lang-icon {\n    font-size: 13px;\n  }\n\n  .lang-text {\n    font-size: 12px;\n  }\n\n  .lang-chevron {\n    font-size: 9px;\n  }\n\n  .language-dropdown {\n    min-width: 160px;\n    right: -10px;\n  }\n\n  .language-option {\n    padding: 10px 14px;\n  }\n\n  .language-native {\n    font-size: 13px;\n  }\n\n  .language-english {\n    font-size: 11px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
